export const PORTAL_PLATFORMS = [
  "willhaben",
  "immoscout24",
  "immowelt",
  "derstandard",
  "findmyhome",
  "wohnnet",
  "nachrichten",
  "laendleimmo",
  "alleimmo",
];
